import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

@Component({
  selector: "app-skeleton-details",
  imports: [CommonModule],
  templateUrl: "./skeleton-details.component.html",
  styleUrl: "./skeleton-details.component.scss",
})
export class SkeletonDetailsComponent {}
